/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { List$1 } from "./List$1";
import { Number_$type, markType } from "./type";
/**
 * @hidden
 */
var DoubleCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DoubleCollection, _super);
    function DoubleCollection() {
        return _super.call(this, Number_$type, 0) || this;
    }
    DoubleCollection.$t = markType(DoubleCollection, 'DoubleCollection', List$1.$.specialize(Number_$type));
    return DoubleCollection;
}(List$1));
export { DoubleCollection };
//# sourceMappingURL=DoubleCollection.js.map
